module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VG1004-c78a967410972c0f6245ba7c28a1cf01.png";